import {PageLink} from '../../../../_metronic/layout/core'
import {useInvestorDatabase} from './InvestorContext'
import {useIntl} from 'react-intl'

export const InvestorDatabase = () => {
  const intl = useIntl()

  const InvestorDatabaseProspectiveBreadCrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const InvestorDatabaseExistingBreadCrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const InvestorDatabaseBreadCrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return {
    InvestorDatabaseBreadCrumbs,
    InvestorDatabaseProspectiveBreadCrumbs,
    InvestorDatabaseExistingBreadCrumbs,
  }
}

export const Constants = () => {
  const intl = useIntl()
  const {companyName, investorId} = useInvestorDatabase()

  const IndividualInvestorBreadCrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'Investor Database'}),
      path: '/investor-database/all-investor',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    // {
    //   title: `${companyName}`,
    //   path: '',
    //   isSeparator: false,
    //   isActive: false,
    // },
  ]

  const ImportInvestorBreadCrumbs: Array<PageLink> = [
    {
      title: 'Home',
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'Investor Database'}),
      path: '/investor-database/prospective-investor',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const IndividualInvestorUserBreadCrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'Investor Database'}),
      path: '/investor-database/prospective-investor',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: `${companyName}`,
      path: `/investor-database/individual-investor/${investorId}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return {
    IndividualInvestorBreadCrumbs,
    IndividualInvestorUserBreadCrumbs,
    ImportInvestorBreadCrumbs,
  }
}

export const CreateInvestorBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Settings',
    path: '',
    isSeparator: false,
    isActive: false,
  },
]

export const options = [
  {value: 'Seed Funds', label: 'Seed Funds'},
  {value: 'Series A', label: 'Series A'},
  {value: 'Series B', label: 'Series B'},
  {value: 'Series C', label: 'Series C'},
  {value: 'Series D', label: 'Series D'},
]
export const investorType = [
  {value: 'Venture Capital', label: 'Venture Capital'},
  {value: 'Angel Investors', label: 'Angel Investors'},
  {value: 'Individual Investor', label: 'Individual Investor'},
  {value: 'Institutional Investors', label: 'Institutional Investors'},
  {value: 'Corporate Investors', label: 'Corporate Investors'},
  {value: 'Crowdfunding', label: 'Crowdfunding'},
  {value: 'Private Equity', label: 'Private Equity'},
  {value: 'Family Offices', label: 'Family Offices'},
  {value: 'Accelerators', label: 'Accelerators'},
  {value: 'Incubators', label: 'Incubators'},
  {value: 'Government Grants', label: 'Government Grants'},
  {value: 'Friends and Family', label: 'Friends and Family'},
]

export const recordOptions = [
  {
    id: 1,
    name: 'Skip',
    value: 'Skip',
  },
  {
    id: 2,
    name: 'Include',
    value: 'Include',
  },
]

export const leftDummyData = [
  'Salutation',
  'First Name',
  'Contact Id',
  'Office Phone',
  'Last name',
  'Mobile phone',
  'Organization name',
  'Home phone',
  'Lead source',
  'Secondary phone',
  'Home phone2',
  'Lead source2',
  'Secondary phone2',
]

export const importInvestorTable = [
  {
    id: 1,
    name: 'Company Name',
  },
  {
    id: 2,
    name: 'User name',
  },
  {
    id: 3,
    name: 'user email',
  },
  {
    id: 4,
    name: 'Phone number',
  },
]

export const sortInvestorDbConst = [
  // {id: 1, name: 'select sorting order', value: '', disabled: true},
  {id: 2, name: '(asc) fundsize ', value: 'fund_size-ASC'},
  {id: 3, name: '(desc) fundsize ', value: 'fund_size-DESC'},
  {id: 2, name: '(asc) createdAt ', value: 'createdAt-ASC'},
  {id: 3, name: '(desc) createdAt ', value: 'createdAt-DESC'},
]

export const designationOptions: any[] = [
  {
    id: 1,
    name: 'Series B - Saltbox',
    value: 'Series B - Saltbox',
  },
  {
    id: 2,
    name: 'Series A - Daylight',
    value: 'Series A - Daylight',
  },
  {
    id: 3,
    name: 'Seed Round - Bridge ...',
    value: 'Seed Round - Bridge ...',
  },
]

export const errorReportsConstant = [
  {id: 26, name: 'Investor Profile is incorrect.', value: 'Investor Profile is incorrect.'},
  {
    id: 27,
    name: "Investor's Investment Thesis is incorrect.",
    value: "Investor's Investment Thesis is incorrect.",
  },
  {
    id: 28,
    name: "Investor's Social media profiles are incorrect.",
    value: "Investor's Social media profiles are incorrect.",
  },
  {
    id: 29,
    name: "The contact person's information is incorrect.",
    value: "The contact person's information is incorrect.",
  },
  {id: 30, name: 'The investor/fund has been closed.', value: 'The investor/fund has been closed.'},
  {id: 31, name: 'Others', value: 'Others'},
]

export const fundTypeOptions = [
  {
    id: 435,
    label: 'Limited Partners',
    value: 'Limited Partners',
  },
  {
    id: 436,
    label: 'Venture Capital',
    value: 'Venture Capital',
  },
  {
    id: 437,
    label: 'Accelerators/Incubators',
    value: 'Accelerators/Incubators',
  },
  {
    id: 438,
    label: 'Angel Groups',
    value: 'Angel Groups',
  },
  {
    id: 439,
    label: 'Family Offices',
    value: 'Family Offices',
  },
  {
    id: 440,
    label: 'Corporate Venture Capital',
    value: 'Corporate Venture Capital',
  },
  {
    id: 441,
    label: 'Angel Investors',
    value: 'Angel Investors',
  },
  {
    id: 442,
    label: 'PE/Buyout',
    value: 'PE/Buyout',
  },
  {
    id: 443,
    label: 'Investment Banks & Service Providers',
    value: 'Investment Banks & Service Providers',
  },
  {
    id: 444,
    label: 'Lenders',
    value: 'Lenders',
  },
  {
    id: 445,
    label: 'Fund of Funds',
    value: 'Fund of Funds',
  },
  {
    id: 446,
    label: 'Registered Investment Advisors',
    value: 'Registered Investment Advisors',
  },
  {
    id: 447,
    label: 'Institutional Investors',
    value: 'Institutional Investors',
  },
  {
    id: 448,
    label: 'Real Estate Private Equities',
    value: 'Real Estate Private Equities',
  },
  {
    id: 449,
    label: 'Foundations',
    value: 'Foundations',
  },
  {
    id: 450,
    label: 'Investment Consultants',
    value: 'Investment Consultants',
  },
  {
    id: 451,
    label: 'Friends and Family',
    value: 'Friends and Family',
  },
]

export const InvestorDBFilter = () => {
  const {formatMessage} = useIntl()

  const fundTypeOptions = [
    {
      id: 435,
      label: formatMessage({id: 'Limited Partners'}),
      value: 'Limited Partners',
    },
    {
      id: 436,
      label: formatMessage({id: 'Venture Capital'}),
      value: 'Venture Capital',
    },
    {
      id: 437,
      label: formatMessage({id: 'Accelerators/Incubators'}),
      value: 'Accelerators/Incubators',
    },
    {
      id: 438,
      label: formatMessage({id: 'Angel Groups'}),
      value: 'Angel Groups',
    },
    {
      id: 439,
      label: formatMessage({id: 'Family Offices'}),
      value: 'Family Offices',
    },
    {
      id: 440,
      label: formatMessage({id: 'Corporate Venture Capital'}),
      value: 'Corporate Venture Capital',
    },
    {
      id: 441,
      label: formatMessage({id: 'Angel Investors'}),
      value: 'Angel Investors',
    },
    {
      id: 442,
      label: formatMessage({id: 'PE/Buyout'}),
      value: 'PE/Buyout',
    },
    {
      id: 443,
      label: formatMessage({id: 'Investment Banks & Service Providers'}),
      value: 'Investment Banks & Service Providers',
    },
    {
      id: 444,
      label: formatMessage({id: 'Lenders'}),
      value: 'Lenders',
    },
    {
      id: 445,
      label: formatMessage({id: 'Fund of Funds'}),
      value: 'Fund of Funds',
    },
    {
      id: 446,
      label: formatMessage({id: 'Registered Investment Advisors'}),
      value: 'Registered Investment Advisors',
    },
    {
      id: 447,
      label: formatMessage({id: 'Institutional Investors'}),
      value: 'Institutional Investors',
    },
    {
      id: 448,
      label: formatMessage({id: 'Real Estate Private Equities'}),
      value: 'Real Estate Private Equities',
    },
    {
      id: 449,
      label: formatMessage({id: 'Foundations'}),
      value: 'Foundations',
    },
    {
      id: 450,
      label: formatMessage({id: 'Investment Consultants'}),
      value: 'Investment Consultants',
    },
    {
      id: 451,
      label: formatMessage({id: 'Friends and Family'}),
      value: 'Friends and Family',
    },
  ]

  const sortInvestorDbConst = [
    // {id: 1, name: 'select sorting order', value: '', disabled: true},
    {id: 2, name: formatMessage({id: '(asc) fundsize '}), value: 'fund_size-ASC'},
    {id: 3, name: formatMessage({id: '(desc) fundsize '}), value: 'fund_size-DESC'},
    {id: 2, name: formatMessage({id: '(asc) createdAt '}), value: 'createdAt-ASC'},
    {id: 3, name: formatMessage({id: '(desc) createdAt '}), value: 'createdAt-DESC'},
  ]

  return {
    fundTypeOptions,
    sortInvestorDbConst,
  }
}
